import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import load from "../../assets/Images/loader.gif";

const BroadbandBuilding = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "14px",
    },
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectState, setSelectState] = useState("");
  const [optionState, setOptionState] = useState([]);
  const [selectCity, setSelectCity] = useState();
  const [optionCity, setOptionCity] = useState([]);
  const [selectArea, setSelectArea] = useState();
  const [optionArea, setOptionArea] = useState([]);
  const [selectSociety, setSelectSociety] = useState();
  const [optionSociety, setOptionSociety] = useState([]);
  const [productAll, setProductAll] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const url = process.env.REACT_APP_API_URL_2;
      const data = {
        Action: "getSpecState",
        Authkey: "AdgT6SnjAkeLqlkE4",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const result = await response.json();
        // console.log("state", result.Response);
        if(result.StatusCode === "200"){
          setOptionState(result.Response);
        }
      } catch (error) {
        console.error("Error fetching data", error.message);
      }
    };

    fetchApi();
  }, []);

  const handleSelectState = async (state) => {
    setSelectState(state);
    setSelectCity(null); // Reset city when state changes
    setSelectArea(null); // Reset area when state changes
    setSelectSociety(null); // Reset society when state changes
    setProductAll([]);
    const url = process.env.REACT_APP_API_URL_2;
    const data = {
      Action: "getcity",
      Authkey: "AdgT6SnjAkeLqlkE4",
      password: sessionStorage.getItem("password"),
      stateCode: state.value,
      userName: sessionStorage.getItem("userName"),
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("City", result.Response);
      if(result.StatusCode==="200"){
      setOptionCity(result.Response);
    }else{
      
      toast.warning("City Not Available", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 500,
      });
    }
    } catch (error) {
      console.error("Error fetching data", error.message);
    }
  };

  const handleSelectCity = async (city) => {
    setSelectCity(city);
    setSelectArea(null); // Reset area when city changes
    setSelectSociety(null);
    setProductAll([]);
    const url = process.env.REACT_APP_API_URL_2;
    const data = {
      Action: "getarea",
      Authkey: "AdgT6SnjAkeLqlkE4",
      cityCode: city.value,
      cityName: city.label,
      password: sessionStorage.getItem("password"),
      restrictedarea: true,
      stateCode: "",
      userName: sessionStorage.getItem("userName"),
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("Area", result.Response);
      if(result.StatusCode==="200"){
      setOptionArea(result.Response);
    }
    } catch (error) {
      console.error("Error fetching data", error.message);
    }
  };

  const handleSelectArea = async (area) => {
    setSelectArea(area);
    setSelectSociety(null);
    setProductAll([]);
    const url = process.env.REACT_APP_API_URL_2;
    const data = {
      Action: "getsociety",
      Authkey: "AdgT6SnjAkeLqlkE4",
      areaCode: area.value,
      password: sessionStorage.getItem("password"),
      userName: sessionStorage.getItem("userName"),
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("Society", result.Response);
      if(result.StatusCode==="200"){
      setOptionSociety(result.Response);
      }else{
        setOptionSociety([]);
        toast.warning(result.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
      }
    } catch (error) {
      console.log("Error fetching data", error.message);
    }
  };

  const handleSelectSociety = async (society) => {
    setSelectSociety(society);
    if (!society) {
      setProductAll([]); // Reset productAll if no society is selected
      return;
    }
    try {
      setIsLoading(true)
    const url = process.env.REACT_APP_API_URL_2;
    const data = {
      Action: "readproduct",
      Authkey: "AdgT6SnjAkeLqlkE4",
      password: sessionStorage.getItem("password"),
      societyCode: society.value,
      userName: sessionStorage.getItem("userName"),
    };
    
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("product", result.Response);
      setProductAll(result.Response);
    } catch (error) {
      console.log("Error fetching data", error.message);
    }
    finally{
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();
  const redirectBroadbandPage = () => {
    navigate("/broadband");
  };
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3" style={{ whiteSpace: "nowrap" }}>
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBroadbandPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-2">Building/Society vs Plan Availability</span>
        </div>
      </div>

      {isLoading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      ) : (
      <div className="buildingSearch-bg" style={{ marginTop: "63px" }}>
        <form className="lead-form p-2">
          <div className="">
            <label className="select-search-label mt-1 mb-1">State*</label>
            <Select
              className=" basic-single form-control form-control-sm  p-1"
              classNamePrefix="select"
              name="CustContactable"
              placeholder="Select State*"
              styles={style}
              value={selectState}
              isSearchable={false}
              onChange={handleSelectState}
              options={optionState.map((data) => ({
                value: data.StateCode,
                label: data.StateName,
              }))}
            />
          </div>
          <div className="">
            <label className="select-search-label mb-1 mt-1">City*</label>
            <Select
              className=" basic-single form-control form-control-sm  p-1"
              classNamePrefix="select"
              name="CustContactable"
              placeholder="Select City*"
              styles={style}
              value={selectCity}
              isSearchable={false}
              onChange={handleSelectCity}
              options={optionCity.map((data) => ({
                value: data.CityCode,
                label: data.CityName,
              }))}
            />
          </div>

          <div className="">
            <label className="select-search-label mb-1  mt-1">Area*</label>
            <Select
              className=" basic-single form-control form-control-sm  p-1"
              classNamePrefix="select"
              name="CustContactable"
              placeholder="Select Area*"
              styles={style}
              value={selectArea}
              isSearchable={false}
              onChange={handleSelectArea}
              options={optionArea.map((data) => ({
                value: data.AreaCode,
                label: data.AreaName,
              }))}
            />
          </div>

          <div className="">
            <label className="select-search-label mb-1 mt-1">Society*</label>
            <Select
              className=" basic-single form-control form-control-sm  p-1"
              classNamePrefix="select"
              name="CustContactable"
              placeholder="Select Society*"
              styles={style}
              value={selectSociety}
              isSearchable={false}
              onChange={handleSelectSociety}
              options={optionSociety.map((data) => ({
                value: data.SocietyCode,
                label: data.SocietyName,
              }))}
            />
          </div>
        </form>
      </div>)}

      <div className="container-fluid mt-3">
        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 card-container">
          {productAll.map((product, index) => (
            <div className="col" key={index}>
              <div className="card mb-2">
                <div className=" p-1 card-data">
                  {/* <p className="lead-card-text product-card" ><span className=''>Product Name :</span> {product.ProductNumber}</p> */}
                  {/* <p className="lead-card-text product-card"><span className=''>Product ID : </span>{product.ProductName}</p> */}
                  <div className="row">
                    <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>
                      Product Name :
                    </div>
                    {/* <div className="col-1 ">:</div> */}
                    <div className="col-8">{product.ProductNumber}</div>
                  </div>
                  <div className="row">
                    <div className="col-4 text-weight-color">
                    Product ID :
                    </div>
                    {/* <div className="col-1 ">:</div> */}
                    <div className="col-8">{product.ProductName}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BroadbandBuilding;
